const phoneFormat = (value) => {
  let start = value.slice(0, 3)
  let main = value.slice(3, 7)
  let end = value.slice(7)
  return start + "-" + main + "-" + end
}
export {
  phoneFormat
}